import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ErrorPopupComponent } from '../error-popup/error-popup.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'server-communication-error',
  templateUrl: './server-communication-error.component.html',
  styleUrls: ['./server-communication-error.component.css']
})
export class ServerCommunicationErrorComponent implements OnInit {

  @Input() title: any;
  @Input() text: string;
  @Input() complementary: string;

  constructor(
    protected dialogRef: NbDialogRef<ErrorPopupComponent>,
    private translate: TranslateService
  ) 
  { 
    this.title = "";
    this.text = "";
    this.complementary = "";
  }

  ngOnInit(): void {
    
  }

  verify(): void {
    this.dialogRef.close();
  }
}
